type CategorySlug = (typeof categoryList)[number]["slug"];
type CategoryHash = (typeof categoryList)[number]["referenceId"];
type Category = {
  referenceId: number;
  slug: string;
  label: Translation;
};

type SubCatSlug = (typeof subCatList)[number]["slug"];
type SubCatHash = (typeof subCatList)[number]["referenceId"];

const categoryList = [
  {
    referenceId: 1,
    slug: "weapon",
    label: ["gen-destiny2:category.weapon", "Weapon"],
  },
  {
    referenceId: 16,
    slug: "quest-step",
    label: ["gen-destiny2:category.quest-step", "Quest Step"],
  },
  {
    referenceId: 18,
    slug: "currencies",
    label: ["gen-destiny2:category.currencies", "Currencies"],
  },
  {
    referenceId: 19,
    slug: "emblems",
    label: ["gen-destiny2:category.emblems", "Emblems"],
  },
  {
    referenceId: 20,
    slug: "armor",
    label: ["gen-destiny2:category.armor", "Armor"],
  },
  {
    referenceId: 34,
    slug: "engrams",
    label: ["gen-destiny2:category.engrams", "Engrams"],
  },
  {
    referenceId: 35,
    slug: "consumables",
    label: ["gen-destiny2:category.consumables", "Consumables"],
  },
  {
    referenceId: 39,
    slug: "ghost",
    label: ["gen-destiny2:category.ghost", "Ghost"],
  },
  {
    referenceId: 41,
    slug: "shaders",
    label: ["gen-destiny2:category.shaders", "Shaders"],
  },
  {
    referenceId: 42,
    slug: "ships",
    label: ["gen-destiny2:category.ships", "Ships"],
  },
  {
    referenceId: 43,
    slug: "sparrows",
    label: ["gen-destiny2:category.sparrows", "Sparrows"],
  },
  {
    referenceId: 44,
    slug: "emotes",
    label: ["gen-destiny2:category.emotes", "Emotes"],
  },
  {
    referenceId: 50,
    slug: "subclasses",
    label: ["gen-destiny2:category.subclasses", "Subclasses"],
  },
  {
    referenceId: 53,
    slug: "quest",
    label: ["gen-destiny2:category.quest", "Quest"],
  },
  {
    referenceId: 57,
    slug: "aura",
    label: ["gen-destiny2:category.aura", "Aura"],
  },
  {
    referenceId: 58,
    slug: "clan-banner",
    label: ["gen-destiny2:category.clan-banner", "Clan Banner"],
  },
  {
    referenceId: 59,
    slug: "mods",
    label: ["gen-destiny2:category.mods", "Mods"],
  },
  {
    referenceId: 268598612,
    slug: "packages",
    label: ["gen-destiny2:category.packages", "Packages"],
  },
  {
    referenceId: 1112488720,
    slug: "finishers",
    label: ["gen-destiny2:category.finishers", "Finishers"],
  },
  {
    referenceId: 1378222069,
    slug: "seasonal-artifacts",
    label: ["gen-destiny2:category.seasonal-artifacts", "Seasonal Artifacts"],
  },
  {
    referenceId: 1784235469,
    slug: "bounties",
    label: ["gen-destiny2:category.bounties", "Bounties"],
  },
  {
    referenceId: 3109687656,
    slug: "dummies",
    label: ["gen-destiny2:category.dummies", "Dummies"],
  },
  {
    referenceId: 3726054802,
    slug: "patterns",
    label: ["gen-destiny2:category.patterns", "Patterns"],
  },
] as const;

const subCatList = [
  {
    referenceId: 5,
    slug: "auto-rifle",
    label: ["gen-destiny2:category.auto-rifle", "Auto Rifle"],
  },
  {
    referenceId: 6,
    slug: "hand-cannon",
    label: ["gen-destiny2:category.hand-cannon", "Hand Cannon"],
  },
  {
    referenceId: 7,
    slug: "pulse-rifle",
    label: ["gen-destiny2:category.pulse-rifle", "Pulse Rifle"],
  },
  {
    referenceId: 8,
    slug: "scout-rifle",
    label: ["gen-destiny2:category.scout-rifle", "Scout Rifle"],
  },
  {
    referenceId: 9,
    slug: "fusion-rifle",
    label: ["gen-destiny2:category.fusion-rifle", "Fusion Rifle"],
  },
  {
    referenceId: 10,
    slug: "sniper-rifle",
    label: ["gen-destiny2:category.sniper-rifle", "Sniper Rifle"],
  },
  {
    referenceId: 11,
    slug: "shotgun",
    label: ["gen-destiny2:category.shotgun", "Shotgun"],
  },
  {
    referenceId: 12,
    slug: "machine-gun",
    label: ["gen-destiny2:category.machine-gun", "Machine Gun"],
  },
  {
    referenceId: 13,
    slug: "rocket-launcher",
    label: ["gen-destiny2:category.rocket-launcher", "Rocket Launcher"],
  },
  {
    referenceId: 14,
    slug: "sidearm",
    label: ["gen-destiny2:category.sidearm", "Sidearm"],
  },
  {
    referenceId: 41,
    slug: "shaders",
    label: ["gen-destiny2:category.shaders", "Shader"],
  },
  {
    referenceId: 45,
    slug: "helmets",
    label: ["gen-destiny2:category.helmets", "Helmet"],
  },
  {
    referenceId: 46,
    slug: "arms",
    label: ["gen-destiny2:category.arms", "Gauntlets"],
  },
  {
    referenceId: 47,
    slug: "chest",
    label: ["gen-destiny2:category.chest", "Chest"],
  },
  {
    referenceId: 48,
    slug: "legs",
    label: ["gen-destiny2:category.legs", "Legs"],
  },
  {
    referenceId: 49,
    slug: "class-items",
    label: ["gen-destiny2:category.class-items", "Class Item"],
  },
  {
    referenceId: 54,
    slug: "sword",
    label: ["gen-destiny2:category.sword", "Sword"],
  },
  {
    referenceId: 55,
    slug: "mask",
    label: ["gen-destiny2:category.mask", "Mask"],
  },
  {
    referenceId: 56,
    slug: "mods",
    label: ["gen-destiny2:category.mods", "Mods"],
  },
  {
    referenceId: 153950757,
    slug: "grenade-launchers",
    label: ["gen-destiny2:category.grenade-launchers", "Grenade Launcher"],
  },
  {
    referenceId: 713159888,
    slug: "repeatable-bounties",
    label: ["gen-destiny2:category.repeatable-bounties", "Repeatable Bounties"],
  },
  {
    referenceId: 1504945536,
    slug: "linear-fusion-rifles",
    label: [
      "gen-destiny2:category.linear-fusion-rifles",
      "Linear Fusion Rifle",
    ],
  },
  {
    referenceId: 2489664120,
    slug: "trace-rifles",
    label: ["gen-destiny2:category.trace-rifles", "Trace Rifle"],
  },
  {
    referenceId: 3317538576,
    slug: "bows",
    label: ["gen-destiny2:category.bows", "Bow"],
  },
  {
    referenceId: 3871742104,
    slug: "glaives",
    label: ["gen-destiny2:category.glaives", "Glaive"],
  },
  {
    referenceId: 3954685534,
    slug: "submachine-guns",
    label: ["gen-destiny2:category.submachine-guns", "Submachine Gun"],
  },
] as const;

export const CATEGORIES = categoryList.reduce(
  (acc, r) => {
    acc[r.referenceId] = r;
    acc[r.slug] = r;
    return acc;
  },
  {} as Record<CategorySlug | CategoryHash, Category>,
);

export const SUB_CATEGORIES = subCatList.reduce(
  (acc, r) => {
    acc[r.referenceId] = r;
    acc[r.slug] = r;
    return acc;
  },
  {} as Record<SubCatSlug | SubCatHash, Category>,
);

export const WEAPON_SUB_CATEGORIES = [
  SUB_CATEGORIES["auto-rifle"],
  SUB_CATEGORIES.bows,
  SUB_CATEGORIES["fusion-rifle"],
  SUB_CATEGORIES.glaives,
  SUB_CATEGORIES["grenade-launchers"],
  SUB_CATEGORIES["hand-cannon"],
  SUB_CATEGORIES["linear-fusion-rifles"],
  SUB_CATEGORIES["machine-gun"],
  SUB_CATEGORIES["pulse-rifle"],
  SUB_CATEGORIES["rocket-launcher"],
  SUB_CATEGORIES["scout-rifle"],
  SUB_CATEGORIES["shotgun"],
  SUB_CATEGORIES.sidearm,
  SUB_CATEGORIES["sniper-rifle"],
  SUB_CATEGORIES["submachine-guns"],
  SUB_CATEGORIES.sword,
  SUB_CATEGORIES["trace-rifles"],
];

export const ARMOR_SUB_CATEGORIES = [
  SUB_CATEGORIES.helmets,
  SUB_CATEGORIES.chest,
  SUB_CATEGORIES.arms,
  SUB_CATEGORIES.legs,
  SUB_CATEGORIES["class-items"],
];
